/**
 * App shell — header + main content area + AI chat drawer.
 */
import Header from './Header'
import ChatPanel from '../Chat/ChatPanel'

export default function AppShell({ children }) {
  return (
    <div className="min-h-screen bg-surface">
      <Header />
      <main className="app-container py-4 sm:py-6">{children}</main>
      <ChatPanel />
    </div>
  )
}
